import React, { useState } from 'react';
import { useTranslations } from '../translations';
import './RejectionModal.css';

interface RejectionModalProps {
  productTitle: string;
  onConfirm: (reasons: string[]) => void;
  onCancel: () => void;
}

const RejectionModal: React.FC<RejectionModalProps> = ({ 
  productTitle, 
  onConfirm, 
  onCancel 
}) => {
  const t = useTranslations();
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);

  const rejectionReasons = [
    { id: 'inappropriate_content', label: t.rejectionModal.inappropriateContent },
    { id: 'misleading_information', label: t.rejectionModal.misleadingInformation },
    { id: 'poor_quality_images', label: t.rejectionModal.poorQualityImages },
    { id: 'incomplete_details', label: t.rejectionModal.incompleteDetails },
    { id: 'prohibited_items', label: t.rejectionModal.prohibitedItems },
    { id: 'duplicate_listing', label: t.rejectionModal.duplicateListing },
    { id: 'other', label: t.rejectionModal.other },
  ];

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const toggleReason = (reasonLabel: string) => {
    setSelectedReasons(prev =>
      prev.includes(reasonLabel)
        ? prev.filter(label => label !== reasonLabel)
        : [...prev, reasonLabel]
    );
  };

  const handleConfirm = () => {
    if (selectedReasons.length === 0) {
      return; // Don't allow submission without reasons
    }
    onConfirm(selectedReasons);
  };

  return (
    <div className="rejection-modal-overlay" onClick={handleOverlayClick}>
      <div className="rejection-modal-container">
        <div className="rejection-modal-bg"></div>

        <h2 className="rejection-modal-title">{t.rejectionModal.title}</h2>
        <p className="rejection-modal-product-title">{productTitle}</p>
        <p className="rejection-modal-message">{t.rejectionModal.selectReasons}</p>

        <div className="rejection-reasons-list">
          {rejectionReasons.map(reason => (
            <label key={reason.id} className="rejection-reason-item">
              <input
                type="checkbox"
                checked={selectedReasons.includes(reason.label)}
                onChange={() => toggleReason(reason.label)}
                className="rejection-checkbox"
              />
              <span className="rejection-checkbox-custom"></span>
              <span className="rejection-reason-label">{reason.label}</span>
            </label>
          ))}
        </div>

        <div className="rejection-modal-actions">
          <button className="rejection-modal-cancel" onClick={onCancel}>
            {t.common.cancel}
          </button>
          <button 
            className="rejection-modal-confirm" 
            onClick={handleConfirm}
            disabled={selectedReasons.length === 0}
          >
            {t.rejectionModal.confirm}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
